import { render, staticRenderFns } from "./PollQuestionImage.vue?vue&type=template&id=0be9aea6&scoped=true&"
import script from "./PollQuestionImage.vue?vue&type=script&lang=js&"
export * from "./PollQuestionImage.vue?vue&type=script&lang=js&"
import style0 from "./PollQuestionImage.vue?vue&type=style&index=0&id=0be9aea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9aea6",
  null
  
)

export default component.exports